import { TbVolume, TbVolumeOff, TbX } from "solid-icons/tb";
import { type JSX, Show } from "solid-js";
import { useI18n } from "~/i18n";

/**
 * The player's own buttons, laid over its top corner whether it sits on its slot or is docked, so
 * the video can be closed where it plays.
 */
export const DockControls = (props: { muted: boolean; onToggleMute: () => void; onClose: () => void }) => {
  const { t } = useI18n();
  return (
    <div class="absolute inset-e-2 top-2 flex gap-1.5">
      <ControlButton
        label={props.muted ? t("marketing.video.unmute") : t("marketing.video.mute")}
        onClick={props.onToggleMute}
      >
        <Show when={props.muted} fallback={<TbVolume class="size-4" aria-hidden="true" />}>
          <TbVolumeOff class="size-4" aria-hidden="true" />
        </Show>
      </ControlButton>
      <ControlButton label={t("marketing.video.close")} onClick={props.onClose}>
        <TbX class="size-4" aria-hidden="true" />
      </ControlButton>
    </div>
  );
};

const ControlButton = (props: { label: string; onClick: () => void; children: JSX.Element }) => (
  <button
    type="button"
    aria-label={props.label}
    title={props.label}
    onClick={() => props.onClick()}
    class="grid size-8 cursor-pointer place-items-center rounded-full bg-black/60 text-white backdrop-blur-sm transition-colors hover:bg-black/80 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
  >
    {props.children}
  </button>
);
